// =============================================================
// Hero map fade-in. The bg-tint and bg-image are hidden by default
// (see section-hero.css); we add `.is-loaded` to the bg wrapper once
// the map PNG has been decoded so the CSS transition reveals them.
// Without this gate the yellow tint flashes for a moment before the
// inverted map appears on top of it.
// =============================================================

const hero = document.querySelector<HTMLElement>(".section-hero");
const img = document.querySelector<HTMLImageElement>(".section-hero__bg-image img");

if (hero && img) {
  const reveal = () => hero.classList.add("is-loaded");

  // `complete && naturalHeight > 0` means the image is already cached and
  // fully decoded (e.g. on a soft reload). `complete` alone can be true
  // for errored loads, hence the size check.
  if (img.complete && img.naturalHeight > 0) {
    reveal();
  } else {
    img.addEventListener("load", reveal, { once: true });
    // If the image fails, still reveal so the page doesn't stay
    // permanently dark — better to show the tint than nothing.
    img.addEventListener("error", reveal, { once: true });
  }
}
